import {
  Banner,
  ExpandableFees,
  FeesWarningBanner,
  Navigation,
  PageLayout,
} from "@src/components";
import { useSwapContext } from "@src/contexts";
import { Fees, RoutePath } from "@src/interfaces";
import { calculateFees } from "@src/utils";
import { useMemo } from "react";
import { CashBridgePanel } from "./CashBridgePanel";
import { CashBridgeButton } from "./CashBridgeButton";
import { BackArrowIcon } from "@src/assets";

export const MoveCashView = () => {
  const {
    route,
    isFetchingRoute,
    cashToken,
    shift4Fees,
    errorDetails,
    feesToTokenValueRatio,
    acceptedHighFees,
    setAcceptedHighFees,
  } = useSwapContext();

  const gasFees: Fees = useMemo(() => {
    if (!route) {
      return {
        platformFee: "0",
        networkFee: "0",
        onrampFee: "0",
      };
    }

    const { platformFee, networkFee, onrampFee } = calculateFees({
      route,
      cashToken,
      shift4Fees,
    });

    return {
      platformFee: platformFee,
      networkFee: networkFee,
      onrampFee: onrampFee,
    };
  }, [route, shift4Fees, cashToken]);

  return (
    <PageLayout
      navigation={
        <Navigation
          leftItems={[
            {
              content: <BackArrowIcon />,
              path: RoutePath.Wallet,
            },
            {
              content: "Move cash",
              disabled: true,
              path: RoutePath.MoveCash,
            },
          ]}
        />
      }
    >
      <div className="flex flex-col gap-2 h-full">
        <CashBridgePanel />
        <ExpandableFees gasFees={gasFees} isFetchingRoute={isFetchingRoute} />
        <div className="flex flex-col flex-1 justify-end gap-5">
          {errorDetails && (
            <Banner>
              <div className="flex flex-col items-start text-left">
                {errorDetails}
              </div>
            </Banner>
          )}
          <FeesWarningBanner
            feesToTokenValueRatio={feesToTokenValueRatio}
            confirmed={acceptedHighFees}
            setConfirmed={setAcceptedHighFees}
          />
          <CashBridgeButton />
        </div>
      </div>
    </PageLayout>
  );
};
